// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import '@hotwired/turbo-rails'
import * as ActiveStorage from '@rails/activestorage'
import './controllers'
import './config'
import './channels'
import './scheduler'
import NProgress from 'nprogress'

ActiveStorage.start()

import './pwa'
import './sidebar'
import './components'
import './utils/notifications'

// Use the NProgress bar to show the progress of StimulusReflex actions just like .turbo-progress-bar
// document.addEventListener("stimulus-reflex:before", () => {
//   NProgress.start();
// });

// document.addEventListener("stimulus-reflex:after", () => {
//   NProgress.done();
// });
